import tw from 'twin.macro';

export const UnscrollableContainer = tw.div`overflow-hidden h-screen`;
